import { ReactNode } from 'react'
import InternalLink from '@/components/DatoLink/InternalLink'
import ExternalLink from '@/components/DatoLink/ExternalLink'
import { DatoLinkFragment } from '@/components/DatoLink/DatoLink.generated'
import ObviousLink from '@/components/DatoLink/ObviousLink'

type DatoLinkProps = {
	children: ReactNode
	fragment: DatoLinkFragment
	id?: string
	className?: string
	style?: { [key: string]: string | number }
	inactive?: boolean
	params?: string
	onClick?: React.MouseEventHandler<HTMLAnchorElement>
	locale?: string
}

export default function DatoLink({ children, ...props }: DatoLinkProps) {
	if (!props.fragment || !props.fragment.__typename) {
		return null
	}

	switch (props.fragment.__typename) {
		case 'ExternalLinkRecord':
			return (
				<ExternalLink {...props} fragment={props.fragment}>
					{children}
				</ExternalLink>
			)
		case 'InternalLinkRecord':
			return (
				<InternalLink {...props} fragment={props.fragment}>
					{children}
				</InternalLink>
			)
		case 'ObviousLinkRecord':
			return (
				<ObviousLink {...props} fragment={props.fragment}>
					{children}
				</ObviousLink>
			)
		default:
			return null
	}
}
